---
title: Ontology is how you stop the model inventing the business
slug: ontology-and-hallucination
type: linkedin-highlight
status: published
featured: true
summary: An ontology is not a glossary for the chatbot. It is the governed language a generative path is allowed to speak.
sitePublishedAt: "2026-09-18"
originalPublishedAt: "2025-06-01"
lastReviewedAt: "2026-09-18"
audiences:
  - product-developer
themes:
  - platform-architecture
  - prediction-in-production
sourceUrl: https://www.linkedin.com/in/jayvanzyl/
originalAuthor: Jay van Zyl
sourceRelationship: adapted from public LinkedIn themes on ontology and hallucination; replace sourceUrl with the canonical post when filing the next highlight
rightsStatus: first-party
seoDescription: An ontology is the language a generative system is allowed to speak.
canonicalPath: /thinking/ontology-and-hallucination
---

If a generative component can invent an account type, a role, or a next-best-action that the business does not have, the failure is not “the model was creative.” The failure is that the language of the business was not binding.

EcosystemCode treats OWL/RDF and SHACL as that binding. ecosystem.Ai treats fact injection and an ontology catalog the same way on the prediction path. Prompts are not a substitute for a model of the domain.
